import { AlertTriageIcon } from "../Icons/index";
import { Typo } from "../Typo";

type ReferralLinkWidgetErrorProps = {
  errorMessage: string;
  refreshButton: string;
  onRefresh?: () => void;
};

export const ReferralLinkWidgetError = ({
  errorMessage,
  refreshButton,
  onRefresh,
}: ReferralLinkWidgetErrorProps) => (
  <div
    className="flex flex-col items-center gap-3 py-6"
    data-testid="referral-link-widget-error"
  >
    <AlertTriageIcon />
    <Typo
      type="bodyMD"
      smType="bodySM"
      textColor="text-text-secondary"
      classes="text-center"
    >
      {errorMessage}
    </Typo>
    <button
      type="button"
      className="rounded-lg border border-stroke-secondary px-4 py-2 hover:bg-surface-tonal-default"
      onClick={onRefresh}
      data-testid="referral-link-refresh-button"
    >
      <Typo smType="labelSM">{refreshButton}</Typo>
    </button>
  </div>
);
